import MapRadius from "../Maps/MapRadius";
import ModalBasicLayout from "./ModalBasicLayout";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useRebrandBanner } from "../../hooks/useRebrandBanner";

const ModalMapRadius = ({
  modalOpen,
  onCloseModal,
  onCallbackSave = () => {},
  value,
  maxLocations,
  disableRadius,
  disableAISearch,
  platform,
  from,
  integrationID,
  adAccountID,
  campaignContext = "",
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { totalTopOffsetPx } = useRebrandBanner();
  return (
    <ModalBasicLayout
      modalOpen={modalOpen}
      onCloseModal={onCloseModal}
      fullWidth={true}
      maxWidth="xl"
      scroll="paper"
      fullScreen={isMobile}
      hasTitle={!isMobile}
      isMobile={isMobile}
      sxContent={isMobile ? { px: 0, pb: 0 } : undefined}
      sx={{
        "& .MuiDialog-paper": isMobile
          ? {
              maxHeight: "100%",
              height: "100%",
              borderRadius: 0,
              backgroundColor: "transparent",
              backgroundImage: "none",
              boxShadow: "none",
            }
          : {
              maxHeight: `calc(100% - ${totalTopOffsetPx}px)`,
              height: "100%",
              borderRadius: 4,
              backgroundColor: "transparent",
              backgroundImage: "none",
              boxShadow: "none",
            },
        zIndex: 1302,
      }}
    >
      <Box
        sx={{
          overflow: isMobile ? "visible" : "hidden",
          position: "relative",
          display: "flex",
          justifyContent: "center",
          height: isMobile ? "100vh" : "100%",
          pt: isMobile ? "4px" : 0,
          px: isMobile ? "10px" : 0,
          pb: isMobile ? "40px" : 0,
        }}
      >
        {isMobile && (
          <IconButton
            aria-label="close"
            onClick={onCloseModal}
            sx={{
              position: "absolute",
              top: -12,
              right: 3,
              zIndex: 2,
              p: 0.2,
              backgroundColor: "background.paperSecondary",
              color: "background.paperSecondaryContrastText",
              "&:hover": {
                backgroundColor: "background.paperSecondary",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        )}
        <MapRadius
          value={value}
          sx={{ height: "100%", width: "100%" }}
          onCallbackSave={(value) => {
            onCloseModal();
            onCallbackSave(value);
          }}
          maxLocations={maxLocations}
          disableRadius={disableRadius}
          disableAISearch={disableAISearch}
          platform={platform}
          from={from}
          integrationID={integrationID}
          adAccountID={adAccountID}
          campaignContext={campaignContext}
        />
      </Box>
    </ModalBasicLayout>
  );
};

export default ModalMapRadius;
